import { BaseBus } from "./BaseBus";

export class OrderDetailsSelectBus extends BaseBus
{
    CID(): any {
        return this.orderDetailId;
    }
    constructor(data: OrderDetailsSelectBus = null) {
        super(data);
    }
    orderDetailId: any;
    orderId: any;
    inventoryId: any;
    dispatchId: any;
    accountClassId: any;
    quantity: number;
    originalQuantity: number;
    price: number;
    amount: number;
    inventoryDesc: string;
    toBeReturned: boolean;
    inventoryNumber: string;
    dispatchNumber: string;
    supplierId: any;
    isPart: boolean;
    selected: boolean;

}
